








































































import {Vue, Component} from 'vue-property-decorator'
import dataProxy from "@/services/data-proxy.service";
import {PrijavaKvara, RazlogOdbijanjaPrijaveKvara} from "@/services/BackendProxies";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component({})
export default class OdobravanjePrijaveKvara extends mixins(ComponentBaseMixin) {
    prijave = [];
    prijava = new PrijavaKvara();

    razlog = new RazlogOdbijanjaPrijaveKvara();

    dialogVisible = false;

    async created() {
        this.prijave = await this.loadData(() => dataProxy.vratiPrijaveKvara())();
    }

    onClickRow(row) {
        this.prijava = row;
    }

    async prihvatiKvar() {
        const valid = await this.confirmationNeeded('da li ste sigurni da zelite da prihvatite kvar');
        if (valid) {
            this.prijave = await this.saveData(() => dataProxy.odobriPrijavuKvara(this.prijava.id))();
        }
    }

    async odbiKvar() {
        const valid = await (<any>this.$refs.dialogForm).validate();
        if (valid) {
            this.dialogVisible = false;
            await this.deleteData(() => dataProxy.odbiPrijavuKvara(this.prijava.id, RazlogOdbijanjaPrijaveKvara.fromJS({
                prijavaKvaraId: this.prijava.id,
                razlog: this.razlog.razlog
            })))();
            this.prijave = await this.loadData(() => dataProxy.vratiPrijaveKvara())();
            this.prijava.opis = '';
        }
    }

    fokusirajRazlog() {
        (<HTMLElement>this.$refs.razlog).focus();
    }
}
